import termsskincarepro from './terms-skincare-pro/routes';

export default [termsskincarepro];
